import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Alignment, Answer } from '@digilize/shared/definitions/src';

@Component({
  selector: 'lib-single-answer-tiles',
  templateUrl: './single-answer-tiles.component.html',
  styleUrls: ['./single-answer-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SingleAnswerTilesComponent implements OnInit {
  @Input() control: FormControl;
  @Input() options: Answer[] = [];
  @Input() withInnerHTML = false;
  @Input() sameHeightElements = false;
  @Input() align: Alignment = 'left';
  @Output() changed = new EventEmitter<string>();
  constructor() {}

  ngOnInit(): void {}

  handleClick(option: { text: string; val: string }) {
    if (this.control) {
      this.control.setValue(option.val);
    }
    this.changed.emit(option.val);
  }

  handleInfoClick(e: Event) {
    e.stopPropagation();
  }
}
